import React from "react";
import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";

export const Footer = () => {
  return (
    <footer className="border-t border-zinc-200 bg-zinc-950 text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 font-heading font-black text-2xl mb-4">
            <span className="bg-white text-zinc-950 px-2 py-0.5">NEO</span>
            <span>TECH</span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            The technical marketplace for serious builders. Components, peripherals,
            and laptops at sharp prices.
          </p>
        </div>

        <div>
          <h4 className="font-mono uppercase text-xs tracking-[0.2em] mb-4 text-zinc-500">
            Shop
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/products?category=GPU" className="hover:text-[#FF2A00]">Graphics Cards</Link></li>
            <li><Link to="/products?category=CPU" className="hover:text-[#FF2A00]">Processors</Link></li>
            <li><Link to="/products?category=Laptops" className="hover:text-[#FF2A00]">Laptops</Link></li>
            <li><Link to="/products?category=Monitors" className="hover:text-[#FF2A00]">Monitors</Link></li>
            <li><Link to="/products?is_deal=true" className="hover:text-[#FF2A00]">Deals</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono uppercase text-xs tracking-[0.2em] mb-4 text-zinc-500">
            Developers
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/integration-guide" className="hover:text-[#FF2A00]">API Integration Guide</Link></li>
            <li><a href="https://developer.newegg.com/newegg_marketplace_api/" target="_blank" rel="noreferrer" className="hover:text-[#FF2A00]">Newegg Seller API</a></li>
            <li><a href="https://www.impact.com/campaign-directory/newegg/" target="_blank" rel="noreferrer" className="hover:text-[#FF2A00]">Newegg Affiliate</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono uppercase text-xs tracking-[0.2em] mb-4 text-zinc-500">
            Stay sharp
          </h4>
          <p className="text-sm text-zinc-400 mb-4">
            Get notified when prices drop on the gear you watch.
          </p>
          <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-[#FF2A00]">
            <Lightning size={14} weight="fill" /> Real-time deals
          </div>
        </div>
      </div>

      <div className="border-t border-zinc-800 py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-xs font-mono uppercase tracking-wider text-zinc-500 flex flex-col md:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} NeoTech Marketplace · Demo</span>
        <span>Powered by Stripe · Built on FastAPI</span>
      </div>
    </footer>
  );
};
